"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceShareCollaboratorsView = void 0;
var _react = require("react");
var _materialSymbols = require("@design/icons/material-symbols");
var _modalBXsU9PJPGdHkA5xZcxCesE = require("@design-generated/modal-bXsU9PJPGdHkA5xZcxCesE-1713-20094");
var _modalBXsU9PJPGdHkA5xZcxCesE2 = require("@design-generated/modal-bXsU9PJPGdHkA5xZcxCesE-1713-20094.wiring");
var _button = require("@design/ui/button");
var _table = require("@design/ui/table");
var _resourceShareCopy = require("./resource-share-copy");
var _shareGranteeAvatar = require("./share-grantee-avatar");
var _shareRoleSelect = require("./share-role-select");
var _shareConfirmationBanner = require("./share-confirmation-banner");
var _removeCollaboratorDialog = require("./remove-collaborator-dialog");
var _jsxRuntime = require("react/jsx-runtime");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ResourceShareCollaboratorsView = exports.ResourceShareCollaboratorsView = function ResourceShareCollaboratorsView(_ref) {
  var grantees = _ref.grantees,
    owner = _ref.owner,
    currentUser = _ref.currentUser,
    resourceName = _ref.resourceName,
    resourceKind = _ref.resourceKind,
    canManageShares = _ref.canManageShares,
    viewerOnly = _ref.viewerOnly,
    updatingKeys = _ref.updatingKeys,
    removingKeys = _ref.removingKeys,
    error = _ref.error,
    confirmation = _ref.confirmation,
    onChangeRole = _ref.onChangeRole,
    onRemoveCollaborator = _ref.onRemoveCollaborator,
    onClearError = _ref.onClearError,
    onBack = _ref.onBack,
    closeIcon = _ref.closeIcon;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    collaboratorPendingRemoval = _useState2[0],
    setCollaboratorPendingRemoval = _useState2[1];
  var backButtonRef = (0, _react.useRef)(null);
  function openRemoval(grantee) {
    onClearError();
    setCollaboratorPendingRemoval(grantee);
  }
  function cancelRemoval() {
    setCollaboratorPendingRemoval(null);
  }
  function confirmRemoval(_x) {
    return _confirmRemoval.apply(this, arguments);
  }
  function _confirmRemoval() {
    _confirmRemoval = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(grantee) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return onRemoveCollaborator(grantee);
          case 1:
            if (!_context.v) {
              _context.n = 2;
              break;
            }
            cancelRemoval();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _confirmRemoval.apply(this, arguments);
  }
  var headerContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-4",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      ref: backButtonRef,
      variant: "ghost",
      size: "icon-sm",
      "aria-label": "Back",
      onClick: onBack,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-base leading-6 font-medium text-foreground-primary",
      children: "Who has access"
    })]
  });
  function renderPermission(grantee) {
    var role = (0, _resourceShareCopy.granteeRole)(grantee);
    var key = (0, _resourceShareCopy.granteeKey)(grantee);
    if (grantee.kind === "user" && grantee.user.userId === (owner === null || owner === void 0 ? void 0 : owner.userId)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "px-3 text-sm text-foreground-primary",
        children: "Owner"
      });
    }
    if (!canManageShares) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "px-3 text-sm text-foreground-primary",
      children: _resourceShareCopy.GRANT_ROLE_LABELS[role]
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareRoleSelect.ShareRoleSelect, {
      role: role,
      resourceKind: resourceKind,
      disabled: updatingKeys.has(key) || removingKeys.has(key),
      ariaLabel: "Permission for ".concat((0, _resourceShareCopy.granteeName)(grantee)),
      viewerOnly: viewerOnly,
      onRoleChange: function onRoleChange(nextRole) {
        return onChangeRole(grantee, nextRole);
      },
      onRemoveCollaborator: function onRemoveCollaborator() {
        return openRemoval(grantee);
      },
      "data-sentry-element": "ShareRoleSelect",
      "data-sentry-component": "renderPermission",
      "data-sentry-source-file": "resource-share-collaborators-view.tsx"
    });
  }
  function renderCollaboratorRow(grantee) {
    var isCurrentUser = grantee.kind === "user" && grantee.user.userId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
    var detail = (0, _resourceShareCopy.granteeDetail)(grantee);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_table.TableRow, {
      className: "border-none hover:bg-transparent has-aria-expanded:bg-transparent",
      "data-sentry-element": "TableRow",
      "data-sentry-component": "renderCollaboratorRow",
      "data-sentry-source-file": "resource-share-collaborators-view.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_table.TableCell, {
        className: "p-2 w-full max-w-(--spacing-0)",
        "data-sentry-element": "TableCell",
        "data-sentry-source-file": "resource-share-collaborators-view.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex items-center gap-2",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shareGranteeAvatar.ShareGranteeAvatar, {
            grantee: grantee,
            size: "default",
            "data-sentry-element": "ShareGranteeAvatar",
            "data-sentry-source-file": "resource-share-collaborators-view.tsx"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "flex min-w-0 flex-col",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "truncate text-sm leading-5 font-medium text-foreground-primary",
              children: (0, _resourceShareCopy.granteeName)(grantee)
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "truncate text-xs leading-4 text-foreground-muted",
              children: isCurrentUser ? "".concat(detail !== null && detail !== void 0 ? detail : "", " (you)") : detail
            })]
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_table.TableCell, {
        className: "p-2",
        "data-sentry-element": "TableCell",
        "data-sentry-source-file": "resource-share-collaborators-view.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex justify-end",
          children: renderPermission(grantee)
        })
      })]
    }, (0, _resourceShareCopy.granteeKey)(grantee));
  }
  function renderGranteeSection(label, sectionGrantees) {
    if (sectionGrantees.length === 0) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col",
      "data-sentry-component": "renderGranteeSection",
      "data-sentry-source-file": "resource-share-collaborators-view.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-caption text-foreground-muted",
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_table.Table, {
        "data-sentry-element": "Table",
        "data-sentry-source-file": "resource-share-collaborators-view.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_table.TableBody, {
          "data-sentry-element": "TableBody",
          "data-sentry-source-file": "resource-share-collaborators-view.tsx",
          children: sectionGrantees.map(renderCollaboratorRow)
        })
      })]
    });
  }
  var collaboratorSections = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex min-h-0 flex-1 flex-col gap-4 self-stretch overflow-y-auto",
    children: [renderGranteeSection("Individuals", grantees.filter(function (grantee) {
      return grantee.kind === "user";
    })), renderGranteeSection("Teams", grantees.filter(function (grantee) {
      return grantee.kind === "team";
    }))]
  });
  var confirmationBanner = confirmation ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex justify-center self-stretch",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareConfirmationBanner.ShareConfirmationBanner, {
      message: confirmation
    })
  }) : null;
  var errorMessage = error && !collaboratorPendingRemoval ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "text-sm text-destructive-text",
    children: error
  }) : null;
  var removeCollaboratorDialog = collaboratorPendingRemoval ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_removeCollaboratorDialog.RemoveCollaboratorDialog, {
    collaborator: collaboratorPendingRemoval,
    error: error,
    resourceName: resourceName,
    resourceKind: resourceKind,
    isRemoving: removingKeys.has((0, _resourceShareCopy.granteeKey)(collaboratorPendingRemoval)),
    focusFallbackRef: backButtonRef,
    onCancel: cancelRemoval,
    onConfirm: function onConfirm() {
      return confirmRemoval(collaboratorPendingRemoval);
    }
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "max-h-[calc(100vh-16px)] overflow-y-auto rounded-lg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalBXsU9PJPGdHkA5xZcxCesE2.ModalBXsU9PJPGdHkA5xZcxCesE171320094Context.Provider, {
        value: {
          modalHeaderContent: headerContent,
          close: closeIcon,
          modalContent: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [collaboratorSections, confirmationBanner, errorMessage]
          })
        },
        "data-sentry-element": "CollaboratorsContext.Provider",
        "data-sentry-source-file": "resource-share-collaborators-view.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalBXsU9PJPGdHkA5xZcxCesE.ModalBXsU9PJPGdHkA5xZcxCesE171320094Screen, {
          "data-sentry-element": "CollaboratorsScreen",
          "data-sentry-source-file": "resource-share-collaborators-view.tsx"
        })
      })
    }), removeCollaboratorDialog]
  });
};